import { render, staticRenderFns } from "./ModalEditLetter.vue?vue&type=template&id=459d4229&"
import script from "./ModalEditLetter.vue?vue&type=script&lang=js&"
export * from "./ModalEditLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports